var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7445 0.261068C16.6888 1.4031 15.9656 4.70424 10.5154 10.1544L10.149 13.4522L6.85116 16.75L7.21761 13.4522L3.55341 9.78801L0.255615 10.1544L3.55341 6.85666L6.85116 6.49021C12.3013 1.04005 15.4193 0.13362 16.7445 0.261068ZM2.63736 14.3683L3.91981 10.8873L6.11836 13.0858L2.63736 14.3683ZM13.8132 3.19242L12.9682 2.68547L11.6239 3.63772L12.7139 4.29171L13.3437 5.3414L14.2791 3.96894L13.8132 3.19242Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishTest);
export default __webpack_public_path__ + "static/media/publishTest.67386344444f378554f49d5fdc2628bd.svg";
export { ForwardRef as ReactComponent };